import { useNavigate } from 'react-router-dom'
import React, { useMemo } from 'react'
import type { To } from '@remix-run/router'
import type { NavigateOptions } from 'react-router/dist/lib/context'

export const useReactRouterDom = () => {
  const navigate = useNavigate()
  const push = React.useCallback(
    (to: To, options?: NavigateOptions) => {
      navigate(to, options)
    },
    [navigate]
  )

  const goBack = React.useCallback(
    (backCount = -1) => {
      navigate(backCount)
    },
    [navigate]
  )

  return useMemo(() => ({ push, goBack }), [push, goBack])
}
